import { mapState } from 'vuex'
import moment from 'moment'
import filter from 'js/filter'
import { getTicketList, paypalAddOrder } from '@/service/vbef'
import { editXuserChannelByLocalShareChannelId } from 'js/shareChannel'
import {
  Alogin
} from '@/service/app'
import CardPay from '@/components/common/cardPay.vue'
const MOBILE_REGEX = /^1[3-9]\d{9}$/
const signUpMixins = {
  components: { CardPay },
  data() {
    const _this = this
    return {
      filter,
      ticketList: [],
      concurrentList: {
        'zh': [
          `主论坛：释放中国临床与监管新势能，助力全球CGT加速转化`,
          `国际峰会：聚势共生——全球CGT网络协同进化与国际合作论坛`,
          `分论坛1：从罕见病到重大疾病——基因治疗新适应症开发与递送制造创新`,
          `分论坛2：临床转化与全球开发——基因治疗的中国实践与国际化路径`,
          `分论坛3：让创新疗法惠及更多患者——基因治疗新模式、新靶点与转化评价`,
          `分论坛4：全球基因编辑技术开发和临床转化的最新进展和挑战`,
          `分论坛5：In Vivo 细胞治疗在病毒载体递送中的研发与成药路径`,
          `分论坛6：In Vivo 细胞治疗在非病毒载体递送中的技术突破与成药路径`,
          `分论坛7：In Vivo 细胞治疗的临床研究与全生命周期质量控制`,
          `分论坛8：体外免疫细胞治疗在肿瘤领域的临床验证与转化进展`,
          `分论坛9：体外免疫细胞治疗在自身免疫疾病中的临床探索与转化进展`,
          `分论坛10：体外免疫细胞治疗的技术创新与产业化制备`,
          `分论坛11：大国重器，群星璀璨——iPSC多方向突破性创新`,
          `分论坛12：干细胞药物的商业化进程：创新研发、临床突破与规模化发展`,
          `分论坛13：外泌体药物的创新路径：监管科学引领下的药物开发与质量标准建立`,
          `分论坛14：小核酸药物递送突破与产业化生态论坛——从技术创新到全链条产业化生态构建`,
          `分论坛15：个体化VS现货型——肿瘤疫苗双轨并行下的技术抉择与临床验证`,
          `分论坛16：AI赋能个性化肿瘤疫苗——从研发到商业化落地`,
          `分论坛17：CGT全生命周期的CMC质量体系与CDMO协同策略`,
          `分论坛18：从IIT到IND——CMC与CDMO的成本与效率博弈`,
          `分论坛19：AI×生命科学——生命世界模型的基石与平台`,
          `分论坛20：药物研发×AI——智能体驱动的创新药产业革命`,
          `分论坛21：创新方法评价（NAMs）论坛——CGT成药中的人体相关模型与创新评价体系`,
          `闭门会：NAMs创新方法评价研讨会`,
          `分论坛22：中国IIT与临床转化：医企协同构建全球研发新支点`,
          `闭门会：818号令对IIT的备案政策解读`,
          `分论坛23：中美细胞与基因治疗青年科学家论坛暨对接交流会（定邀制）`,
          `大会活动：中国IIT资源对接会`,
          `大会活动：CGT海外BD资源对接会`,
          `大会活动：项目路演`,
          `大会活动：CSGCT欢迎晚餐交流会`,
          `大会活动：CSGCT鸡尾酒晚会`,
          `大会活动：CSGCT VIP 深度考察团--临床应用与付费转化之旅`,
        ],
        'en': [
          `Plenary Forum: Unlocking China's Clinical and Regulatory Momentum to Accelerate Global CGT Translation`,
          `Global Summit: United in Synergy – The Global CGT Network for Co-Evolution and International Collaboration`,
          `Session 1: From Rare Diseases to Major Diseases – New Indications Development and Delivery & Manufacturing Innovation for Gene Therapy`,
          `Session 2: Clinical Translation and Global Development – China's Practice and Internationalization Path for Gene Therapy`,
          `Session 3: Bringing Innovative Therapies to More Patients – New Modalities, Novel Targets, and Translational Evaluation in Gene Therapy`,
          `Session 4: Latest Advances and Challenges in Global Gene Editing Technology Development and Clinical Translation`,
          `Session 5: In Vivo Cell Therapy – R&D and Druggability Pathways for Viral Vector Delivery`,
          `Session 6: In Vivo Cell Therapy – Technological Breakthroughs and Druggability Pathways for Non-Viral Delivery`,
          `Session 7: In Vivo Cell Therapy – Clinical Research and Lifecycle Quality Control`,
          `Session 8: Clinical Validation and Translational Progress of Ex Vivo Immune Cell Therapy in Oncology`,
          `Session 9: Clinical Exploration and Translational Progress of Ex Vivo Immune Cell Therapy in Autoimmune Diseases`,
          `Session 10: Technological Innovation and Industrial Manufacturing of Ex Vivo Immune Cell Therapy`,
          `Session 11: iPSC Breakthrough Innovations Across Multiple Directions`,
          `Session 12: Commercialization of Stem Cell Medicines – Innovative R&D, Clinical Breakthroughs, and Scalable Development`,
          `Session 13: Innovative Pathways for Exosome-Based Medicines – Regulatory Science–Driven Drug Development and Quality Standards Establishment`,
          `Session 14: Oligonucleotide Drug Delivery Breakthroughs and Industrialization Ecosystem Forum – From Technological Innovation to Full-Chain Ecosystem Development`,
          `Session 15: Personalized vs. Off-the-Shelf – Technology Choices and Clinical Validation in Cancer Vaccines`,
          `Session 16: AI-Empowered Personalized Cancer Vaccines – From R&D to Commercialization`,
          `Session 17: CMC Quality Systems Across the CGT Lifecycle and CDMO Collaboration Strategies`,
          `Session 18: From IIT to IND – Navigating Cost-Efficiency Dynamics Between CMC and CDMO`,
          `Session 19: AI × Life Sciences – Cornerstone and Platform for Modeling the Living World`,
          `Session 20: Drug R&D × AI – Agent-Driven Revolution in the Innovative Pharmaceutical Industry`,
          `Session 21: NAMs (New Approach Methodologies) Forum – Human-Relevant Models and Innovative Evaluation Systems for CGT Drug Development`,
          `Closed-Door Session: NAMs Innovative Methods Evaluation Workshop`,
          `Session 22: China IITs and Clinical Translation – Building Global R&D Hubs Through Industry-Hospital Collaboration`,
          `Closed-Door Session: Interpretation of the Filing Policy for IITs Under Order No. 818`,
          `Session 23: China–U.S. Young Scientists Forum on Cell and Gene Therapy & Matchmaking Exchange (By Invitation Only)`,
          `China IIT Resource Matchmaking Session`,
          `CGT Global BD Resource Matchmaking Session`,
          `Project Pitch Session`,
          `CSGCT Welcome Dinner Reception (By Invitation Only)`,
          `CSGCT Cocktail Reception (By Invitation Only)`,
          `CSGCT VIP Deep Dive Tour – Clinical Application and Reimbursement Translation Journey`,
        ]
      },
      companyprofileother: false,
      companyProfileList: [
        filter.dealLanguage('大型药企', 'Big Pharma'),
        filter.dealLanguage('CGT 创新药企', 'CGT Innovative Pharmaceutical Company '),
        filter.dealLanguage('投资机构（人民币）', 'Investment Agency (RMB Fund)'),
        filter.dealLanguage('投资机构（美元）', 'Investment Agency (USD Fund)'),
        filter.dealLanguage('MNC', 'MNC'),
        filter.dealLanguage('临床前CRO企业 ', 'Pre-clinical CRO'),
        filter.dealLanguage('临床CRO企业 ', 'Clinical CRO '),
        filter.dealLanguage('CMO/CDMO企业', 'CMO/CDMO'),
        filter.dealLanguage(
          '供应链产品企业（原材料、试剂耗材、仪器设备等）',
          'Supply-Chain Solutions Provider(APIs、Reagent & Consumable Materials、Instrument & Equipment,etc.)'
        ),
        filter.dealLanguage('第三方检测服务企业', 'Testing Service Provider'),
        filter.dealLanguage('细胞存储企业', 'Cell Storage Services'),
        filter.dealLanguage(
          '国际业务服务企业（金融机构、律所等）',
          'Global Business Services(Financial Institution, Law Firm, etc.)'
        ),
        filter.dealLanguage('科研院所/高校', 'Academic & Research Institution/University'),
        filter.dealLanguage('医院/临床机构', 'Hospital/clinical institution'),
        filter.dealLanguage('监管机构/行业协会', 'Regulators/Industry Association'),
        filter.dealLanguage(
          '产业园区/孵化器/加速器等 ',
          'Industrial Park/Incubator/Accelerator, etc.'
        ),
        filter.dealLanguage('患者组织 ', 'Patient Group'),
        filter.dealLanguage('其他，请填写 ', 'Others, please specify'),
      ],
      currentAddressDto: [],
      addressDtoList: [],
      addressDtos: [],
      currentForm: {
        name: '',
        compName: '',
        entityId: 0,
        title: '',
        email: '',
        addressId: '',
        companyProfile: '',
        companyprofileother: '',
        concurrent2: [],
        mobile: '',
        mobileAreaCode: '86',
        enmobile: '',
        whether: '',
        whether2: '',
        whether2content: [],
        whether2other: '',
        invitedRecommendedBy: '',
        xs: '',
        name2: '',
        email2: '',
        company2: '',
        position2: '',
        qnForum: '',
        routerName: this.$route.name,
      },
      ruleValidate2: {
        name: [
          {
            required: true,
            message: filter.dealLanguage('请填写姓名', 'Please fill in your name'),
            trigger: 'blur',
          },
        ],
        compName: [
          {
            required: true,
            message: filter.dealLanguage('请搜索并选择公司', 'Please search and select a company'),
            trigger: 'change',
          },
        ],
        department: [
          {
            required: true,
            message: filter.dealLanguage('请填写部门', 'Please fill in the department'),
            trigger: 'blur',
          },
        ],
        title: [
          {
            required: true,
            message: filter.dealLanguage('请填写职位', 'Please fill in the position'),
            trigger: 'blur',
          },
        ],
        addressId: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        companyProfile: [
          {
            required: true,
            message: filter.dealLanguage('请选择公司性质', 'Please select'),
            trigger: 'change',
          },
        ],
        whether: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        whether2: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        companyprofileother: [
          {
            required: true,
            message: filter.dealLanguage('请填写具体性质', 'Please fill in the specific nature'),
            trigger: 'blur',
          },
        ],
        concurrent2: [
          {
            required: true,
            type: 'array',
            message: filter.dealLanguage('请选择会议或活动', 'Please select a meeting or event'),
            trigger: 'change',
          },
        ],
        need2: [
          {
            required: true,
            max: 3,
            min: 3,
            type: 'array',
            message: filter.dealLanguage(
              '请选出最重要的3项需求',
              'Please select the top 3 requirements'
            ),
            trigger: 'change',
          },
        ],
        service2: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        activityTicketName: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        activityTicketNameEn: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        verifyCode: [
          {
            required: true,
            message: filter.dealLanguage(
              '请输入验证码',
              'Please enter the verification code'
            ),
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            validator: this.validateCode
          },
        ],
        email: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的邮箱', 'Please enter your E-mail'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: filter.dealLanguage('邮箱格式不正确', 'The E-mail format is incorrect'),
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的手机号', 'Please enter your mobile number'),
            trigger: 'blur',
          },
          {
            type: 'number',
            message: filter.dealLanguage(
              '手机号格式不正确',
              'The phone number format is incorrect'
            ),
            trigger: 'blur',
            transform(value) {
              if (_this.currentForm.mobileAreaCode == '86')
                return MOBILE_REGEX.test(value) ? Number(value) : false
            },
          },
        ],
        enmobile: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的手机号', 'Please enter your mobile number'),
            trigger: 'blur',
          },
        ],
        xs: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ],
        name2: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的姓名', 'Please enter your name'),
            trigger: 'blur',
          },
        ],
        email2: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的邮箱', 'Please enter your E-mail'),
            trigger: 'blur',
          },
        ],
        company2: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的公司名称', 'Please enter your company name'),
            trigger: 'blur',
          },
        ],
        position2: [
          {
            required: true,
            message: filter.dealLanguage('请输入您的职务', 'Please enter your position'),
            trigger: 'blur',
          },
        ],
        qnForum: [
          {
            required: true,
            message: filter.dealLanguage('请选择', 'Please select'),
            trigger: 'change',
          },
        ]
      },
      paymentWay: 1,
      isVerifyCode: false
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      user_key: (state) => state.user_key,
      appMobileAreaCodeDtos: (state) => state.appMobileAreaCodeDtos,
      activityId: (state) => state.activityId,
      activityDetail: (state) => state.activityDetail,
      user: (state) => state.user,
      isWeixinBrowser: (state) => state.isWeixinBrowser,
      vbef_path: (state) => state.vbef_path,
      index2_path: (state) => state.index2_path,
      language: (state) => state.language,
      isMobile: (state) => state.isMobile,
      channelDiscountRate: (state) => state.channelDiscountRate,
    }),
    //是否能够报名
    canSignUp() {
      if (this.$route.name == 'offline') return true
      const deadline = moment('2026-09-17 17:00:00', 'YYYY-MM-DD HH:mm:ss')
      return moment().isBefore(deadline)
    }
  },
  methods: {
    ininUserInfo() {
      const user = this.$store.state.user
      this.currentForm.name = user.name || ''
      this.currentForm.compName = user.compName || ''
      this.entityKeyword = user.compName || ''
      this.currentForm.entityId = user.entityId || 0
      this.currentForm.department = user.department || ''
      this.currentForm.title = user.title || ''
      this.currentForm.companyNatureId = user.companyNatureId || null
      this.currentForm.companyNatureOtherTagName = user.companyNatureOtherTagName || ''
      this.currentForm.mobile = user.mobile || ''
      this.currentForm.mobileAreaCode = user.mobileAreaCode || ''
      this.currentForm.email = user.email.includes('@privaterelay.appleid.com') ? '' : (user.email || '')
      if (this.wxCode) this.genOpenidByWechatCode()
    },
    async getTicketList() {
      let res = await getTicketList({
        actId: this.activityId,
        payType: this.language == 'zh' ? 1 : 2,
      })
      if (res.code == 0) {
        const list = this.$route.name == 'special' ? 
          res.data.filter((a) => ![149].includes(Number(a.id))) : 
          res.data.filter((a) => ![210, 211, 216, 217, 218, 219].includes(Number(a.id)))

        this.$set(this.$data, 'ticketList', list)
        
        if (list.length) {
          this.currentTicket = list[0]
          this.currentForm.activityTicketId = list[0].id
        }
      }
    },
    handleChangeNT(value, isfirst = 0) {
      if (!isfirst) this.currentForm.companyNatureOtherTagName = ''
      if (!value || !this.companyNatureTags.length) {
        this.compNTother = ''
        return
      }
      let item = this.companyNatureTags.find((a) => a.id === value)
      if (
        item.name.indexOf('其他') > -1 ||
        item.name.indexOf('Other') > -1 ||
        item.name.indexOf('other') > -1
      ) {
        this.compNTother = item.name
      } else {
        this.compNTother = ''
      }
    },
    submitEn() {
      if (!this.canSignUp) {
        return false
      }
      if (this.buttonLoading) return
      this.$refs['current-form'].validate(async (valid) => {
        if (valid) {
          this.buttonLoading = true
          const orderParams = this.setOrderParams()
          if (this.paymentWay == 1 && this.currentTicket.price) {
            const formParams = {
              email: this.currentForm.email,
            }
            this.$refs['card-pay'].handlePay(orderParams, formParams)
            return
          }
          let res = await paypalAddOrder(orderParams)
          this.buttonLoading = false
          if (res.code == 0) {
            if (res.data.activityTicketUserRelationId) {
              this.$router.push({
                name: 'ticketDetail',
                params: { id: res.data.activityTicketUserRelationId }
              })
            }
            if (res.data.paypalUrl) {
              window.location.href = res.data.paypalUrl
            }
          } else {
            if (this.isMobile) {
              this.$notify(res.enMsg || res.msg)
            } else {
              this.$Message.error(res.enMsg || res.msg)
            }
          }
        } else {
          if (this.isMobile) {
            this.$notify('Please complete the form and submit it')
          } else {
            this.$Message.error('Please complete the form and submit it')
          }

        }
      })
    },
    setOrderParams() {
      let { activityTicketId, ...params } = this.currentForm
      let ticketParamsStr = JSON.stringify(params)
      return {
        activityTicketId: activityTicketId,
        checkFormJson: ticketParamsStr,
        loginPlatform: this.isMobile ? 9 : 8,
        payType: 4,
      }
    },
    handleSelectPaymentOption(value) {
      this.paymentWay = value
    },
    updateLoading(loading) {
      this.buttonLoading = loading
    },
    async validateCode(rule, value, callback) {  // 2手机号 11 邮箱登录
      if (this.isVerifyCode) {
        callback()
        return
      }

      let params = {
        loginPlatform: this.isMobile ? 9 : 8,
        type: this.language == 'zh' ? 2 : 11,
        email: this.currentForm.email || '',
        mobileAreaCode: this.currentForm.mobileAreaCode || '',
        mobile: this.currentForm.mobile || '',
        code: this.currentForm.verifyCode,
      }
      let res = await Alogin(params)
      if (res.code == 0) {
        this.$store.commit('updateUserKey', res.data.userKey)
        this.isVerifyCode = true
        if (this.wxCode) this.genOpenidByWechatCode()
        editXuserChannelByLocalShareChannelId(this.$store.state.activityId)
        callback()
      } else {
        this.$store.commit('updateUserKey', null)
        this.isVerifyCode = false
        callback(new Error(filter.dealLanguage(
          res.msg,
          res.enMsg
        )));
      }
    },
    handleUpdateMobile() {
      this.$store.commit('updateUserKey', null)
      this.isVerifyCode = false
      this.currentForm.mobile = ''
      this.currentForm.verifyCode = ''
      this.currentForm.email = ''
    }
  },
}
export { signUpMixins }
